module.exports = __webpack_public_path__ + "img/eye-open.0cde07bc.svg";